var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "417 322 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.563 7.562c0 3.867 3.133 7 7 7 3.866 0 7-3.133 7-7 0-3.866-3.134-7-7-7-3.867 0-7 3.134-7 7Zm8.241-3.274v3.274h2.002c.302 0 .454.367.24.58l-3.244 3.225a.336.336 0 0 1-.477 0L4.08 8.141a.339.339 0 0 1 .24-.579h2.002V4.288a.34.34 0 0 1 .338-.338h1.807a.34.34 0 0 1 .338.338Z",
    fillRule: "evenodd",
    fill: "url(\"#a\")",
    transform: "translate(416.438 321.438)",
    "data-name": "Icon awesome-arrow-alt-circle-up"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f04e23",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f68b1f",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.963c6644f5ec474cd2af9d55119e9590.svg";
export { ForwardRef as ReactComponent };